import React from 'react';
import BrandLogo from './BrandLogo';
import MarketingPanel from './MarketingPanel';
import './AuthLayout.css';

/**
 * Auth Layout
 * Split-screen layout inspired by the reference auth design:
 * the login form on one side and a branding/marketing panel on the other.
 */
function AuthLayout({ title, subtitle, children }) {
    return (
        <div className="auth-layout">
            <div className="auth-layout__panel">
                <div className="auth-layout__logo">
                    <BrandLogo />
                </div>

                <div className="auth-layout__body">
                    <h1 className="auth-layout__title">{title}</h1>
                    {subtitle && (
                        <p className="auth-layout__subtitle">{subtitle}</p>
                    )}

                    <div className="auth-layout__form">{children}</div>
                </div>

                <footer className="auth-layout__footer">
                    <p>با ورود به سامانه، شرایط و قوانین را می‌پذیرید</p>
                </footer>
            </div>

            <MarketingPanel />
        </div>
    );
}

export default AuthLayout;
